module.exports = __webpack_public_path__ + "static/img/3.5ee59d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/sp/3.png
// module id = /TI+
// module chunks = 0